var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        width: "600"
      },
      model: {
        value: _vm.dialog,
        callback: function callback($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [_vm._v(" View/Download SSH key ")]
          ),
          _c(
            "v-card-text",
            {
              staticClass: "text-center"
            },
            [
              !_vm.loading
                ? [
                    _c(
                      "p",
                      {
                        staticClass: "text-left"
                      },
                      [_vm._v(_vm._s(_vm.keyDescription))]
                    ),
                    _c("v-textarea", {
                      attrs: {
                        outlined: "",
                        value: _vm.sshKeyText,
                        "hide-details": "",
                        readonly: "",
                        "no-resize": "",
                        rows: "8"
                      }
                    })
                  ]
                : _c("v-progress-circular", {
                    attrs: {
                      indeterminate: "",
                      color: "primary",
                      size: "64"
                    }
                  })
            ],
            2
          ),
          _c(
            "v-card-actions",
            {
              staticClass: "justify-content-end pb-3"
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    secondary: ""
                  },
                  on: {
                    click: _vm.close
                  }
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "gg-btn",
                {
                  attrs: {
                    disabled: _vm.loading
                  },
                  on: {
                    click: _vm.copy
                  }
                },
                [_vm._v("Copy to Clipboard")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }